export default {"src":"/_next/static/media/stressMotivationMobile.dfa871a3.svg","height":232,"width":272,"blurWidth":0,"blurHeight":0};